<template>
    <ul>
        <li v-if='!env.isCompanyDomain'><a href="e" class="btn btn-danger btn-exam-entry"><i class="fa fa-pencil"></i> 考试入口</a>
        <li v-if="enableRegister">
            <a href="login#!view=register" class="btn btn-primary-o">注册</a>
        </li>
        <li>
            <a href="login" class="btn btn-primary">登录</a>
        </li>
    </ul>
</template>

<script lang="babel">
    /**
     * Footer
     */
    import { LoginType, CompanyPerm } from 'core/constant'
    import { company, env } from 'bootsets/runtime'
    export default{
        data() {
            return {
                env
            }
        },
        computed: {
            // 是否允许注册: 1 sso 不允许; 2 百一测评 允许; 3 企业版 看权限
            enableRegister() {
                switch (+env.loginType) {
                case LoginType.SELF:
                    return true
                case LoginType.COMPANY:
                    return company.perm & CompanyPerm.TEACHER_REGISTER || company.perm & CompanyPerm.STUDENT_REGISTER
                case LoginType.COMPANY_SSO:
                    return false
                }
            }
        },
        ready() {
        }
    }
</script>
<style scoped>
    li {
        float: right;
        height: 54px;
        line-height: 54px;
    }

    li > a {
        padding: 4px 15px;
        margin: 0 0 0 14px;
    }

    .btn-exam-entry {
        background: #ff7674;
        border: 1px solid #ff7674;
        font-size: 14px;
    }

    .btn-exam-entry:hover {
        background: #ED5565;
        border: 1px solid #ED5565;
    }
</style>



// WEBPACK FOOTER //
// not-login-corner.vue?15c7d41e